import { Environment } from '@/scripts/exposed-api/types/store-information'
import VirtualMirror from '../virtual-mirror/VirtualMirror'
import { IVirtualMirrorModule } from './types/VirtualMirrorModule'
import { StoreInformationMapper } from '@/scripts/exposed-api/StoreInformation'

export class VirtualMirrorModule {
  static getConfig(): IVirtualMirrorModule {
    const config = VirtualMirror.mapConfig()
    const vmExperience = true
    const vmEnv = VirtualMirrorModule.findEnvironment(StoreInformationMapper.mapEnvironment())

    return {
      ...config,
      vmEnv,
      vmExperience,
    }
  }

  private static findEnvironment(env: string): string {
    return env === Environment.PROD ? env : 'TEST'
  }
}
